// Ionic & Angular Imports
import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';

// Provider Imports 
import {IEmployee} from './employee.service';


// Interfaces
export interface Labor {
    id: number;
    employee: IEmployee;
    starttime: string;
    finishtime: string;
    notes: string;
}

@Injectable()
export class rsLaborSvc 
{ 
    constructor(
        public http: Http, 
    ) {
        // Class constructor
    }

    getLaborers( reportId : number ) : Observable<Labor[]> {
        return Observable.create( observer => {

            this.http.get( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/labor', {
                withCredentials: true
            })
            .map( res => res.json().response.laborers )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    }

    addLabor( employeeid : number, starttime: string, finishtime: string, notes: string, reportId : number ) : Observable<Labor> {
        return Observable.create( observer => {

            let postData = {
                employeeid : employeeid,
                starttime : starttime,
                finishtime : finishtime,
                notes : notes
            };

            let body = JSON.stringify(postData);
            let headers = new Headers( {
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials : true } );
            this.http.post( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/labor', body, options )
            .map( res => res.json().response.laborers )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    };

    updateLabor( laborId : number, employeeid : number, starttime: string, finishtime: string, notes: string, reportId : number ) : Observable<Labor> {
        return Observable.create( observer => {

            let patchData = {
                employeeid : employeeid,
                starttime : starttime,
                finishtime : finishtime,
                notes : notes
            };

            let body = JSON.stringify(patchData);
            let headers = new Headers({
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials: true } );
            this.http.patch( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/labor/' + laborId, body, options )
            .map( res => res.json().response.laborers )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });  
    }
    
    deleteLabor( laborId : number, reportId : number ) : Observable<void> {
        return Observable.create( observer => {

            this.http.delete( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/labor/' + laborId, {
                withCredentials: true
            })
            .map( res => res.json() )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/labor.service.ts